import React from "react";

function DownloadApp() {
  return (
    <div className="download">
      <h2>Download Our App</h2>
      <iframe
        width="700"
        height="430"
        src="https://www.youtube.com/embed/FNt1bX7fnfw"
        title="Mobile App Advertisement"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
    </div>
  );
}

export default DownloadApp;
